import { useContext, useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Typography, Toolbar, Button, IconButton, Grid } from '@mui/material';
import { Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem } from '@mui/material';
import { appUserContext } from 'helpers/services';
import UserMenu from './UserMenu';
import LocaleMenu from './LocaleMenu';
import AdminMenu from './AdminMenu';
import { MdMenu as MenuIcon } from 'react-icons/md';
import Sidebar from './Sidebar';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';


let NavBar = () => {
    let { formatMessage } = useIntl();

    let { currentUser, isMobile } = useContext(appUserContext);
    let [showSidebar, setShowSidebar] = useState(false);

    let buttonRef = useRef<HTMLButtonElement>(null);

    let [open, setOpen] = useState(false);

    const handleClose = (event: any) => {
        if (buttonRef.current && buttonRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };


    return (
        <AppBar elevation={0} position="sticky">
            <Toolbar variant="dense" >
                <RouterLink to="/">
                    <img alt="Simec My" style={{ width: 40, textAlign: 'center' }} src="/images/logo_ipad.png" />
                </RouterLink>
                {process.env.REACT_APP_ENVIRONMENT === "staging" &&
                    <Typography component="span" style={{ color: '#354249', whiteSpace: 'nowrap' }}>
                        <strong>Staging env.</strong>
                    </Typography>
                }

                {isMobile === true &&
                    <Grid container alignItems="center" p={0}>
                        <Grid item xs p={0} />
                        <Grid item p={0}>
                            <IconButton color="inherit" size="large" onClick={() => setShowSidebar(true)}>
                                <MenuIcon />
                            </IconButton>
                        </Grid>
                        <Sidebar
                            sidebarOpen={showSidebar}
                            closeSidebar={() => setShowSidebar(false)}
                        />
                    </Grid>
                }

                {isMobile === false &&
                    <Grid container alignItems="center" p={0}>
                        <Grid item xs p={0}>
                            {currentUser.simecClaims?.cannotWorkOnTickets === false &&
                                <Button
                                    component={RouterLink}
                                    style={{ color: 'white' }}
                                    to={'/tickets'}
                                >
                                    Tickets
                                </Button>
                            }

                            {(currentUser?.simecClaims?.canViewScheduling === true
                                || currentUser?.simecClaims?.canEditScheduling === true
                                || currentUser?.simecClaims?.canViewSummary === true) &&

                                <Button style={{ color: 'white' }} ref={buttonRef} onClick={() => setOpen(true)}>
                                    {formatMessage({ id: LocalizationIds.People })}
                                </Button>
                            }

                            {currentUser.simecClaims?.canManageTicketInbox === true &&
                                <Button
                                    component={RouterLink}
                                    style={{ color: 'white' }}
                                    to={'/tickets/inbox'}
                                >
                                    Inbox
                                </Button>
                            }

                            <Popper open={open} anchorEl={buttonRef.current} role={undefined} transition disablePortal>
                                {({ TransitionProps, placement }) => (
                                    <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
                                        <Paper>
                                            <ClickAwayListener onClickAway={handleClose}>
                                                <MenuList id="split-button-menu">
                                                    {(currentUser?.simecClaims?.canViewScheduling === true || currentUser?.simecClaims?.canEditScheduling === true) &&
                                                        <div>
                                                            <MenuItem component={RouterLink} to='/scheduling' onClick={handleClose}>
                                                                {formatMessage({ id: LocalizationIds.Scheduling })}
                                                            </MenuItem>
                                                            <MenuItem component={RouterLink} to={'/absences'} onClick={handleClose}>
                                                                {formatMessage({ id: LocalizationIds.Absence })}
                                                            </MenuItem>
                                                        </div>
                                                    }
                                                    {currentUser?.simecClaims?.canViewSummary === true &&
                                                        <MenuItem component={RouterLink} to='/customerssummary' onClick={handleClose}>
                                                            {formatMessage({ id: LocalizationIds.CustomersSummary })}
                                                        </MenuItem>
                                                    }
                                                </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>

                            {currentUser?.simecClaims?.canManageTools === true &&
                                <Button
                                    component={RouterLink}
                                    style={{ color: 'white' }}
                                    to={'/tools'}
                                >
                                    Strumenti
                                </Button>
                            }

                            {currentUser?.simecClaims?.canManageCustomerUsers === true &&
                                <Button
                                    component={RouterLink}
                                    style={{ color: 'white' }}
                                    to={'/customers'}
                                >
                                    Clienti
                                </Button>
                            }
                        </Grid>

                        <Grid item p={0}>
                            <LocaleMenu />
                        </Grid>
                        {(currentUser?.simecClaims?.canManageSimecUsers === true
                            || currentUser?.simecClaims?.canManageTicketCategories === true
                            || currentUser?.simecClaims?.canManageToolTypologies === true
                            || currentUser?.simecClaims?.canManageCanGoToCustomerSimecUsers === true
                        ) &&
                            <Grid item p={0}>
                                <AdminMenu />
                            </Grid>
                        }
                        <Grid item p={0}>
                            <UserMenu />
                        </Grid>
                    </Grid>
                }
            </Toolbar>
        </AppBar>
    );
}

export default NavBar;